export default __webpack_public_path__ + "static/media/3.45d0f924.jpg";